export const useScheduleShifts = () => {
  return {
    rows: [{ label: 'Shifts', rows: [{ label: 'Shifts here too ' }] }],
  };
};
